import styled from 'styled-components'

export const TextBlock = styled.div`
  display: block;
  width: 100%;
`
